import { rgba } from 'polished';
import '../tokens/border-radiuses.js';
import { colorAlphas } from '../tokens/color-alphas.js';
import '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * Collection of alias tokens for tint colors. Designed for nuanced visual feedback during user
 * interactions. These semi-transparent tints modify the brightness of underlying elements, either
 * lightening or darkening based on the chosen effect.
 */ const tintColorAliases = {
    lighten: {
        none: 'transparent',
        ...Object.entries(colorAlphas).reduce((colors, [key, alpha])=>({
                ...colors,
                [key]: rgba('white', alpha)
            }), {})
    },
    darken: {
        none: 'transparent',
        ...Object.entries(colorAlphas).reduce((colors, [key, alpha])=>({
                ...colors,
                [key]: rgba('black', alpha)
            }), {})
    }
};

export { tintColorAliases };
//# sourceMappingURL=tint-colors.js.map
